import React from 'react';
import PropTypes from 'prop-types';
import { Typography, IconButton, Box, Tooltip } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import InnerContent from '../../../components/PageStructure/InnerContent/InnerContent';

import PageContent from '../../../components/PageStructure/PageContent/PageContent';
import PageHeader from '../../../components/PageStructure/PageHeader/PageHeader';

import globals from '../../../globals/communityGlobals';
import PatientForm from '../Form/PatientForm';

const locale = globals.getArea('patients');
const actionTypes = {
  create: 'CREATE',
};

const PatientAdd = props => {
  const { submitAction, goBack, navigate } = props;

  return (
    <PageContent pageTitle={locale.getMsg('addPatient')}>
      <div className="flex-page-content content-wrapper">
        <PageHeader>
          <Box className="title-section" display="flex" alignItems="center" px={2} py={1}>
            <Box>
              <Tooltip title={locale.getMsg('back')}>
                <IconButton
                  className="back-btn"
                  aria-label="back"
                  size="small"
                  color="primary"
                  onClick={() => goBack()}
                >
                  <ArrowBackIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
            </Box>
            <Box flexGrow={1}>
              <Typography variant="h3"> {locale.getMsg('addPatient')}</Typography>
            </Box>
          </Box>
        </PageHeader>
        <InnerContent isBorderless>
          <div className="full-page">
            <PatientForm actionType={actionTypes.create} submitAction={submitAction} navigate={navigate} />
          </div>
        </InnerContent>
      </div>
    </PageContent>
  );
};

PatientAdd.propTypes = {
  submitAction: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
};

export default PatientAdd;
